import React from 'react'

class Footer extends React.Component {
  render() {
    return(
      <div id="footer">
        <p className="copyright">Copyright &copy; 2018-2019 Yoshimasa Suzuki. All Rights Reserved.</p>
      </div>
    )
  }
}

export default Footer
